import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function SolutionCard({
  index,
  eyebrow,
  title,
  description,
  bullets = [],
  to,
  icon: Icon,
  variant = "light",
  testId,
  ctaLabel = "Explore",
  className = "",
}) {
  const isDark = variant === "dark";
  return (
    <Link
      to={to}
      data-testid={testId || "solution-card"}
      className={`card-lift block group relative ${
        isDark
          ? "bg-navy text-white border border-white/10"
          : "bg-white text-navy border border-slate-200"
      } p-8 sm:p-10 ${className}`}
    >
      {index ? (
        <div
          className={`absolute top-7 right-7 text-xs uppercase tracking-[0.22em] ${
            isDark ? "text-gold" : "text-gold-500"
          }`}
        >
          {String(index).padStart(2, "0")} /
        </div>
      ) : null}

      <div
        className={`h-11 w-11 flex items-center justify-center rounded-sm ${
          isDark
            ? "bg-gold text-navy"
            : "bg-navy text-gold"
        }`}
      >
        {Icon ? <Icon size={20} strokeWidth={1.5} /> : null}
      </div>

      {eyebrow ? (
        <div
          className={`mt-7 text-[11px] uppercase tracking-[0.22em] ${
            isDark ? "text-white/60" : "text-slate-500"
          }`}
        >
          {eyebrow}
        </div>
      ) : null}

      <h3
        className={`mt-2 font-display text-2xl sm:text-3xl font-light tracking-tight ${
          isDark ? "text-white" : "text-navy"
        }`}
      >
        {title}
      </h3>

      <p
        className={`mt-4 text-[15px] leading-relaxed ${
          isDark ? "text-white/70" : "text-slate-600"
        }`}
      >
        {description}
      </p>

      {bullets?.length ? (
        <ul className="mt-6 space-y-2">
          {bullets.map((b) => (
            <li
              key={b}
              className={`flex items-start gap-2 text-sm ${
                isDark ? "text-white/80" : "text-slate-700"
              }`}
            >
              <span
                className={`mt-2 h-[3px] w-3 shrink-0 ${
                  isDark ? "bg-gold" : "bg-navy"
                }`}
              />
              {b}
            </li>
          ))}
        </ul>
      ) : null}

      <div
        className={`mt-8 inline-flex items-center gap-2 text-sm font-semibold uppercase tracking-[0.18em] ${
          isDark ? "text-gold" : "text-navy"
        }`}
      >
        {ctaLabel}
        <ArrowUpRight
          size={16}
          className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        />
      </div>
    </Link>
  );
}
